import { render, staticRenderFns } from "./ValidationForms.vue?vue&type=template&id=4b4d8b99&scoped=true"
import script from "./ValidationForms.vue?vue&type=script&lang=js"
export * from "./ValidationForms.vue?vue&type=script&lang=js"
import style0 from "./ValidationForms.vue?vue&type=style&index=0&id=4b4d8b99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4d8b99",
  null
  
)

export default component.exports